<div class="report-conversions">
  @if (error()) {
  <div class="alert alert-danger py-2 mb-3">{{ error() }}</div>
  }

  <div class="data-header">
    <div class="conversions-kpis">
      <div>
        <div class="card card-box data-details px-1 py-3" data-kpi="conversions">
          <div class="icon"><i class="fas fa-hand-holding-usd"></i></div>
          <div class="title dark-text">
            Successful Conversions
            <app-info-popover info="People who registered through a referral and are now contacts of this project. Only those matching the filters above are counted."></app-info-popover>
          </div>
          <div class="count">{{ summary() ? summary().conversions : '–' }}</div>
        </div>
      </div>
      <div>
        <div class="card card-box data-details px-1 py-3" data-kpi="referrers">
          <div class="icon"><i class="fa fa-users"></i></div>
          <div class="title dark-text">
            Unique Referrers
            <app-info-popover info="How many different people brought in at least one conversion. Someone who referred five people counts once."></app-info-popover>
          </div>
          <div class="count">{{ summary() ? summary().referrers : '–' }}</div>
        </div>
      </div>
      <div>
        <div class="card card-box data-details px-1 py-3" data-kpi="average">
          <div class="icon"><i class="fa fa-line-chart"></i></div>
          <div class="title dark-text">
            Avg. Conversions / Referrer
            <app-info-popover info="Successful Conversions divided by Unique Referrers: how many people each referrer brought in on average."></app-info-popover>
          </div>
          <div class="count">{{ summary() ? (summary().averagePerReferrer | number:'1.0-2') : '–' }}</div>
        </div>
      </div>
      <div>
        <div class="card card-box data-details px-1 py-3" data-kpi="unmatched">
          <div class="icon"><i class="fa fa-chain-broken"></i></div>
          <div class="title dark-text">
            Unmatched Referrer IDs
            <app-info-popover info="Conversions whose referrer is no longer a contact of this project, so their details cannot be shown. 0 means every referrer was found."></app-info-popover>
          </div>
          <div class="count">{{ summary() ? summary().unmatchedReferrers : '–' }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="conversions-sections">
    <div>
      <div class="card card-box advocates">
        <div class="card-header d-flex flex-wrap align-items-center justify-content-between referral-id-card-header">
          <div class="card-header--title">
            <div class="advocates-title">
              <i class="fa fa-trophy" style="margin-right: 0.5rem;"></i>
              <span class="dark-text">Top Referrers</span>
            </div>
          </div>
          @if (canExport() && summary()?.conversions) {
          <div class="advocates-check-box d-flex align-items-center">
            <img class="cursor-pointer ms-3 me-1 conversions-export-icon" [matMenuTriggerFor]="conversionsExportMenu"
                 src="../../assets/images/import-normal.png" alt=""> <label class="mb-0 cursor-pointer" [matMenuTriggerFor]="conversionsExportMenu">Export</label>
            <mat-menu #conversionsExportMenu="matMenu" class="campaign-popover">
              <a class="dropdown-item" (click)="exportData('csv')">
                <i class="fa fa-file-o me-2"></i>CSV</a>
              <a class="dropdown-item" (click)="exportData('xlsx')">
                <i class="fa fa-file-excel-o me-2"></i>Excel (xlsx)</a>
            </mat-menu>
          </div>
          }
        </div>
        <div class="card-body p-2">
          <p class="conversions-hint mb-2">Open a referrer to see the people they brought in.</p>
          <app-sb-table
            [rows]="rows()"
            [totalRows]="totalRows()"
            [columns]="tableColumns"
            [options]="tableOptions"
            (stateChange)="onTableState($event)"
            (rowExpand)="onRowExpand($event)">

            <ng-template sbTableCell="name" let-row>
              @if (asReferrer(row).matched) {
              <span class="fw-bold">{{ asReferrer(row).name || '-' }}</span>
              }
              @if (!asReferrer(row).matched) {
              <span class="text-muted">Unmatched referrer #{{ asReferrer(row).id }}</span>
              }
            </ng-template>
            <ng-template sbTableCell="conversions" let-row>
              <span class="fw-bold">{{ asReferrer(row).conversions }}</span>
            </ng-template>

            <ng-template sbTableChild let-row>
              @let people = referredOf(asReferrer(row));
              <div class="conversions-referred">
                @if (people.loading && !people.list) {
                <div class="text-secondary small p-2">Loading…</div>
                }
                @if (people.list) {
                <table class="sb-table-child table mb-0">
                  <thead>
                  <tr>
                    <th>Referred Person</th>
                    <th>Email</th>
                    <th>Type</th>
                    <th>Job Title</th>
                    <th>Company</th>
                    <th>Campaign</th>
                    <th>Converted At</th>
                  </tr>
                  </thead>
                  <tbody>
                  @for (person of people.list; track person) {
                  <tr>
                    <td>{{ person.name || '-' }}</td>
                    <td>{{ person.email }}</td>
                    <td>{{ person.type }}</td>
                    <td>{{ person.jobTitle }}</td>
                    <td>{{ person.company }}</td>
                    <td>{{ person.campaign }}</td>
                    <td>{{ formatDate(person.createdAt) }}</td>
                  </tr>
                  }
                  @if (!people.list.length) {
                  <tr>
                    <td colspan="7" class="text-secondary">No conversions for the selected filters.</td>
                  </tr>
                  }
                  </tbody>
                </table>
                }
                @if (people.list && people.list.length < people.total) {
                <div class="p-2">
                  <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="people.loading"
                          (click)="loadReferred(asReferrer(row), (people.page || 1) + 1)">
                    Show more ({{ people.total - people.list.length }} left)
                  </button>
                </div>
                }
              </div>
            </ng-template>
          </app-sb-table>
        </div>
      </div>
    </div>
    <div>
      <div class="card card-box advocates" data-journey>
        <div class="card-header d-flex align-items-center referral-id-card-header">
          <div class="card-header--title">
            <div class="advocates-title">
              <i class="fa fa-road" style="margin-right: 0.5rem;"></i>
              <span class="dark-text">Referral Journey</span>
              <app-info-popover info="Each step starts when its first event falls in the report's dates. Its columns split the people who completed the step by how long it took, as a share of them; the highlighted column is the most common time. Median: half took less, half took longer."></app-info-popover>
            </div>
          </div>
        </div>
        <div class="card-body p-3 journey">
          <p class="journey__intro">
            How long each step takes. Columns: share of the people who completed the step, by how long it took
            (<b>the highlighted column is the most common</b>). Median and average per step. {{ journeyScope() }}
          </p>
          @if (timeToRegisterLimit(); as limit) {
          <p class="conversions-hint journey__filter-hint" data-journey-time-filter>
            <i class="fa fa-filter me-1" aria-hidden="true"></i>Clicked → converted counts only conversions faster than {{ limit }}.
          </p>
          }
          @if (summaryLoading() && !journey()) {
          <div class="text-center py-3">
            <div class="spinner-border text-primary" role="status"></div>
          </div>
          }
          @if (!summaryLoading() && !journeyRows()) {
          <div class="text-secondary py-2" data-journey-empty>No referral journeys for the selected filters.</div>
          }
          @if (journeyRows(); as rows) {
          <div class="journey__grid" [style.--journey-bins]="journeyAxis().length">
            <div class="journey__row journey__head" aria-hidden="true">
              <div class="journey__step">Step</div>
              <div class="journey__bars-head">How long it took: share of reached</div>
              <div class="journey__stat">Median</div>
              <div class="journey__stat">Average</div>
              <div class="journey__stat journey__reached">Reached</div>
            </div>
            @for (row of rows; track row.stage.key) {
            <div class="journey__row" role="group" [attr.aria-label]="row.name" [attr.data-journey-stage]="row.stage.key">
              <div class="journey__step">
                <div class="journey__name dark-text">{{ row.name }}</div>
                <div class="journey__path">{{ row.from }} → {{ row.to }}</div>
                @if (row.stage.key === 'clickToConversion' && showMatchAccuracy() && row.stage.lessAccurate > 0) {
                <p class="conversions-hint journey__notice" data-match-accuracy-notice>
                  {{ lessAccurateNotice() }}
                  <app-info-popover info="Conversions without a tracked click were timed from the referrer's call-to-action clicks: one from the same device fingerprint or IP address, or else the referrer's nearest earlier click. Only staff see this note."></app-info-popover>
                </p>
                }
              </div>
              <div class="journey__bars">
                @for (bar of row.bars; track bar.key) {
                <div class="journey__col">
                  <span class="journey__share" [class.journey__share--top]="bar.mostCommon" aria-hidden="true">{{ bar.share }}</span>
                  <div class="journey__bar" [class.journey__bar--top]="bar.mostCommon" [style.--journey-h]="bar.height"
                       tabindex="0" role="img" [attr.aria-label]="bar.ariaLabel"
                       [ngbPopover]="barTip" [popoverContext]="{row, bar}" triggers="mouseenter:mouseleave focus:blur"
                       placement="top" container="body"></div>
                </div>
                }
              </div>
              <div class="journey__bars journey__row-axis" aria-hidden="true">
                @for (label of journeyAxis(); track $index) {
                <span class="journey__tick">{{ label[0] }}<wbr>{{ label[1] }}</span>
                }
              </div>
              <div class="journey__stat journey__value" data-journey-median>
                <span class="journey__caption">Median</span>{{ row.median }}
              </div>
              <div class="journey__stat journey__value" data-journey-average>
                <span class="journey__caption">Average</span>{{ row.average }}
              </div>
              <div class="journey__stat journey__reached" data-journey-reached>
                <span class="journey__caption">Reached</span>
                <span class="journey__count">{{ row.stage.reached | number }} of {{ row.stage.started | number }}</span>
                <span class="journey__unit">{{ row.unit }}</span>
                @if (row.stage.approximate > 0) {
                <span class="journey__unit" data-journey-approximate>{{ row.stage.approximate | number }} approximate</span>
                }
              </div>
            </div>
            }
            <div class="journey__row journey__axis" aria-hidden="true">
              <div class="journey__step"></div>
              <div class="journey__bars">
                @for (label of journeyAxis(); track $index) {
                <span class="journey__tick">{{ label[0] }}<wbr>{{ label[1] }}</span>
                }
              </div>
            </div>
          </div>
          <p class="conversions-hint journey__footnote mb-0">
            Not reached: started but not completed yet.
            @if (journeyApproximate()) {
            Timed from page visits before widget interactions were tracked (approximate).
            }
          </p>
          }
          <ng-template #barTip let-row="row" let-bar="bar">
            <div class="journey-tip">
              <div class="journey-tip__title">{{ row.name }}: {{ bar.label }}</div>
              <div class="journey-tip__line"><span>{{ row.unit }}</span><b>{{ bar.count | number }}</b></div>
              <div class="journey-tip__line"><span>Share of reached</span><b>{{ bar.share }}</b></div>
              @for (source of bar.sources; track source.label) {
              <div class="journey-tip__line journey-tip__source"><span>{{ source.label }}</span><b>{{ source.count | number }}</b></div>
              }
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  </div>
</div>
